import { render, staticRenderFns } from "./spaceRequestsList.vue?vue&type=template&id=7b2dc453&scoped=true&"
import script from "./spaceRequestsList.vue?vue&type=script&lang=js&"
export * from "./spaceRequestsList.vue?vue&type=script&lang=js&"
import style0 from "./spaceRequestsList.vue?vue&type=style&index=0&id=7b2dc453&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b2dc453",
  null
  
)

export default component.exports